function addStylesToBlock(selector: string, cssText?: string): void {
    const selection = document.querySelector<any>(selector);
    if (selection !== null ) {
    if (cssText && cssText.length > 0) {
      selection.style.cssText = cssText;
    } else {
      selection.removeAttribute('style')
    }
  }
}

function scrollToElement(selector: string, yOffset: number = 0, behavior: ScrollBehavior = 'smooth'): void {
  const element = document.querySelector(selector);
  const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
  window.scrollTo({top: y, behavior});
}

export {
  addStylesToBlock,
  scrollToElement
};



// WEBPACK FOOTER //
// /app/src/app/helpers.ts